const measurementId = (process.env.REACT_APP_GA_MEASUREMENT_ID || "").trim();

let initialized = false;
let lastPageLocation = null;

export function initializeAnalytics() {
  if (!measurementId || initialized) return;
  if (!document.querySelector(`script[data-ga4="${measurementId}"]`)) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    script.dataset.ga4 = measurementId;
    document.head.appendChild(script);
  }
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false, anonymize_ip: true });
  initialized = true;
}

export function trackPageView() {
  if (!measurementId || !initialized || !window.gtag) return;
  const pageLocation = window.location.href;
  if (pageLocation === lastPageLocation) return;
  lastPageLocation = pageLocation;
  window.gtag("event", "page_view", { page_title: document.title, page_location: pageLocation });
}
